import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface AdminLayoutProps {
  children: React.ReactNode;
  title: string;
  currentPath: string;
  onNavigate: (path: string) => void;
}
export function AdminLayout({
  children,
  title,
  currentPath,
  onNavigate
}: AdminLayoutProps) {
  return <div className="flex min-h-screen bg-slate-50" data-id="element-7">
      <Sidebar currentPath={currentPath} onNavigate={onNavigate} data-id="element-8" />
      <div className="flex-1 flex flex-col" data-id="element-9">
        <Header title={title} data-id="element-10" />
        <main className="flex-1 p-8" data-id="element-11">{children}</main>
      </div>
    </div>;
}